import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import SaveIcon from '@material-ui/icons/SaveSharp';
import CloseIcon from '@material-ui/icons/CloseSharp';
import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles((theme) => ({
  primary: {
    '&:hover, &:focus': {
      color: theme.palette.primary.main,
    },
  },
  button: {
    color: 'gray',
    minWidth: '40px',

    '& .cancel-save-btn-text': {
      opacity: '0',
      fontSize: '0.7rem !important',
    },

    '& > .MuiButton-label > svg:not(.MuiCircularProgress-svg)': {
      transition: 'font-size 0.5s',
    },

    '&:hover, &:focus': {
      '& > .MuiButton-label > svg:not(.MuiCircularProgress-svg)': {
        fontSize: '1.8rem',
        transition: 'font-size 0.5s',
      },

      '& .cancel-save-btn-text': {
        opacity: '1',
        transition: 'opacity 0.5s',
      },
    },
  },
  spinnerContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
  },
  loadingSpinner: {
    color: '#6F9CEB',
  },
}));

const FormCancelSaveButton = React.forwardRef(({ disabled, onCancel, onSave, loading = false }, ref) => {
  const { t } = useTranslation();
  const classes = styles();

  return (
    <>
      {onCancel && (
        <Button
          ref={ref ? ref.cancelRef : null}
          type="button"
          onClick={onCancel}
          disabled={loading}
          className={classes.button}
          size="large"
        >
          <span className="cancel-save-btn-text">{t('Cancel')}</span>
          &nbsp;
          <CloseIcon />
        </Button>
      )}
      <Button
        ref={ref ? ref.saveRef : null}
        onClick={onSave}
        disabled={disabled || loading}
        size="large"
        className={clsx(classes.button, classes.primary)}
      >
        {loading ? (
          <span className={classes.spinnerContainer}>
            <CircularProgress size={22} thickness={4} className={classes.loadingSpinner} />
          </span>
        ) : (
          <SaveIcon />
        )}
        &nbsp;
        <span className="cancel-save-btn-text">{t('Save')}</span>
      </Button>
    </>
  );
});

export default FormCancelSaveButton;
